import React from 'react'

import {
  Button,
  Span,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { COLORS, FORMAT } from 'utils'
import { RiscoAbertoProps } from '../../ManagerialCockpit/components/ManagerialCockpitNgt1/ManagerialCockpitNgt1'

interface TableCockPitProps {
  riskOpeningByTimeData: RiscoAbertoProps
}

const TableCockPit: React.FC<TableCockPitProps> = ({
  riskOpeningByTimeData
}) => {
  const corCompetencia =
    riskOpeningByTimeData[7] > 0 ? COLORS.error : COLORS.success

  return (
    <TableContainerStyled>
      <TableStyled>
        <TableHeadStyled>
          <TableRowStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[0]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[1]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[2]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[3]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[4]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[5]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[6]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[7]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[8]}
            </TableCellStyled>
            <TableCellStyled align="left">
              {riskOpeningByTimeData.labels[9]}
            </TableCellStyled>
          </TableRowStyled>
        </TableHeadStyled>
        <TableBodyStyled>
          <TableRowStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(riskOpeningByTimeData.data[0])}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(riskOpeningByTimeData.data[1])}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(riskOpeningByTimeData.data[2])}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(riskOpeningByTimeData.data[3])}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(riskOpeningByTimeData.data[4])}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(riskOpeningByTimeData.data[5])}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(riskOpeningByTimeData.data[6])}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(riskOpeningByTimeData.data[7])}
            </TableCellStyled>
            <TableCellStyled
              align="center"
              backgroundColor={corCompetencia}
              textColor={COLORS.white}
            >
              {FORMAT.currency(riskOpeningByTimeData.data[8])}
            </TableCellStyled>
            <TableCellStyled align="center">
              {riskOpeningByTimeData.data[9]}
            </TableCellStyled>
          </TableRowStyled>
        </TableBodyStyled>
      </TableStyled>
    </TableContainerStyled>
  )
}

export default TableCockPit
